export default {
  install(Vue) {
    Vue.prototype.$formatNumber = function (value) {
      if (value === null || value === undefined || value === "") return "-";
      let num = Number(value);
      if (!isFinite(num)) return String(value);
      if (num === 0) return "0";

      const abs = Math.abs(num);
      if (abs < 1) {
        const estimated = Math.ceil(-Math.log10(abs)) + 2;
        const decimals = Math.min(8, Math.max(2, estimated));
        let fixed = num.toFixed(decimals);
        fixed = fixed.replace(/\.\d*?[1-9](0+)$|\.(0+)$/, (m) => {
          if (m.startsWith(".")) {
            return m.replace(/0+$/, "");
          }
          return "";
        });
        const parts = fixed.split(".");
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return parts.length > 1 ? parts.join(".") : parts[0];
      }

      const str = String(num);
      const parts = str.split(".");
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return parts.length > 1 ? parts.join(".") : parts[0];
    };
  },
};
